
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { WARNING_POPUP_TYPE } from "@/constants/popupTypes";

@Component
export default class ApproveHOPopUp extends Vue {
  @Prop({ type: Boolean, default: true }) readonly visible!: boolean;

  WARNING_POPUP_TYPE = WARNING_POPUP_TYPE;

  showPopup = false;

  @Watch("visible", { immediate: true })
  visibleChanged(val: boolean) {
    this.showPopup = val;
  }

  open() {
    this.showPopup = true;
  }

  close() {
    this.showPopup = false;

    this.$emit("close");
  }

  showErrorPopup(payload) {
    this.open();

    this.mountData(payload);
  }

  status = "";
  message = "";

  mountData(payload) {
    const { status, message } = payload;

    this.status = status;

    this.message = message;
  }

  get displayPopup() {
    return this.message;
  }

  setupErrorHandler() {
    this.$root.$on("show-error-popup", this.showErrorPopup);
  }

  mounted() {
    this.setupErrorHandler();
  }
}
